import React, { ReactElement } from 'react';
import FavoritesButton from 'common/Favorites/FavoritesButton';
import { getFeatureFlagByNameSelector } from 'store/selectors';
import { useAppSelector } from 'store/store';
import { templateSelector } from 'store/selectors/quickViewSelector';

type SkeletonButton = {
  cart: { text: string; button: ReactElement };
  edit: { text: string; button: ReactElement };
  favorites: { text: string; button: ReactElement };
};

const SkeletonContent = () => {
  const favoriteIconEnabled = useAppSelector(getFeatureFlagByNameSelector('addFavoritesEnabled'));
  const listPanelEnabled = useAppSelector(getFeatureFlagByNameSelector('listPanelEnabled'));
  const template = useAppSelector(templateSelector);

  const textButton: SkeletonButton = {
    cart: {
      text: 'Add to Cart',
      button: favoriteIconEnabled && (
        <FavoritesButton icon="outlined" handleFavoritesState={() => {}} disabled />
      ),
    },
    edit: {
      text: 'Update Item',
      button: (
        <div className="quickview-addToCart-box cancel hmf-mr-m">
          <p className="hmf-m-0 hmf-py-xs">Cancel</p>
        </div>
      ),
    },
    saveSelection: {
      text: 'Save Selections',
      button: <></>,
    },
    favorites: {
      text: listPanelEnabled ? 'Add to a List' : 'Add to Favorites',
      button: <></>,
    },
  };

  return (
    <>
      <div className="quickview-caption-box" />
      <div className="quickview-promo-box" />
      <div className="quickview-image-box full-width" />
      <div className="quickview-caption-box" />
      <div className="quickview-attribute-box" />
      <div className="quickview-caption-box" style={{ marginTop: 8 }} />
      <div className="quickview-shipping-box" />
      <div className="quickview-short-box" style={{ marginTop: 8 }} />
      <div className="quickview-quantity-box" />
      <div className="quickview-caption-box " style={{ marginTop: 8 }} />
      <div className="quickview-short-box" />
      <div className="quickview-description-box" />
      <div className="hmf-flex-grow" />
      <div className="quickview-add-to-cart hmf-display-flex">
        {textButton[template].button}
        <div className="quickview-addToCart-box">
          <p className={` hmf-m-0 ${template === 'cart' ? 'cart-text' : 'hmf-py-xs'} `}>
            {textButton[template].text}
          </p>
        </div>
        <div className="hmf-display-flex hmf-flex-row hmf-justify-content-center itemCount" />
      </div>
    </>
  );
};

export default SkeletonContent;
